export default __webpack_public_path__ + "378e1f5cae189f560879fe552aaa2c9e.png";